import { useContext } from 'react'
import { NetworkStatusContext } from './network-status-context.js'

export const useNetworkStatus = () => useContext(NetworkStatusContext)
